<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">设备告警</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <!-- <div class="block-content block-content-full"> -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtn"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label></label>
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">实时告警</p>
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('ID',$event)"
                      >#</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:150px;"
                        @click="getList('CELL_NAME',$event)"
                      >小区名称</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:150px;"
                        @click="getList('CARPORT_NAME',$event)"
                      >车棚名称</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        @click="getList('DEVICE_TYPE',$event)"
                        style="min-width:100px;"
                      >设备类型</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:120px;"
                        @click="getList('DEVICE_SN',$event)"
                      >设备编号</th>
                      <th
                        class="text-left sorting d-xl-table-cell"
                        style="min-width:205px;"
                        @click="getList('ALERT_TIME',$event)"
                      >告警时间</th>
                      <th
                        class="text-center sorting d-xl-table-cell"
                        style="min-width:120px;"
                        @click="getList('ALERT_STATE',$event)"
                      >告警状态</th>
                      <th class="text-center" style="min-width:100px;">操作</th>
                      <!-- <th
                          class="text-left sorting d-xl-table-cell"
                          style="min-width:120px;"
                          @click="getList('ELECTRICITY_METER_NAME',$event)"
                      >所属电表</th>-->
                      <!-- <th class="text-left  d-xl-table-cell" style="min-width:85px;">告警类型</th>
                      <th class="text-left" style="min-width:85px;">告警等级</th>-->
                      <!-- <th
                          class="text-left sorting d-md-table-cell"
                          @click="getList('ALERT_MESSAGE',$event)"
                      >告警信息</th>-->
                    </tr>
                  </thead>
                  <tbody v-if="userPackages.length">
                    <tr v-for="(item, i) in userPackages" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left d-xl-table-cell">{{ item.CELL_NAME}}</td>
                      <td class="text-left d-xl-table-cell">{{ item.CARPORT_NAME}}</td>
                      <td
                        class="text-left d-xl-table-cell"
                      >{{ item.DEVICE_TYPE == '1' ? '充电桩' : '电表'}}</td>
                      <td class="text-left d-xl-table-cell">{{ item.DEVICE_SN}}</td>
                      <td class="text-left d-xl-table-cell">{{ item.ALERT_TIME}}</td>
                      <td class="text-center d-xl-table-cell">
                        <span
                          class="badge badge-pill"
                          :class="{'badge-success':item.ALERT_STATE =='1','badge-secondary':item.ALERT_STATE =='0' }"
                        >{{ showState(item.ALERT_STATE )}}</span>
                      </td>
                      <td class="text-center no-print">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-primary js-tooltip-enabled"
                            title="查看"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="goToDeviceDetail(item.CELL_ID)"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </td>
                      <!-- <td class="text-left d-xl-table-cell">{{ item.ELECTRICITY_METER_NAME}}</td> -->
                      <!-- <td class="text-left  d-xl-table-cell">{{ item.ALERT_TYPE }}</td>
                      <td class="text-left font-w600">{{ item.ALERT_LEVEL }}</td>-->
                      <!-- <td class="text-left d-md-table-cell">{{ item.ALERT_MESSAGE }}</td> -->
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="8">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="userPackages && userPackages.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      userPackages: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      typeStatus: [
        {
          value: 0,
          label: "过载"
        },
        {
          value: 1,
          label: "拔插"
        },
        {
          value: 2,
          label: "充电异常"
        },
        {
          value: 3,
          label: "温度异常"
        },
        {
          value: 4,
          label: "全部"
        }
      ],
      state: "",
      clipboard: null,
      sorting: "",
      orderBy: false
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    state(val, old) {
      if (typeof old === "undefined") return;
      if (JSON.stringify(val) != JSON.stringify(old)) {
        this.getList();
      }
    },
    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    this.getList();
    this.copy();
  },
  methods: {
    goToDeviceDetail(cellId) {
      this.$router.push({ name: `allDeviceDetail`, params: { id: cellId } });
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    showState(val) {
      switch (val) {
        case "0":
          return "离线";
        case "1":
          return "在线";
      }
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (this.state) {
        params["state"] = this.state;
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByRealAlert/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.userPackages = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByRealAlert/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    showLevel(str) {
      switch (str) {
        case "0":
          return "过载";
        case "1":
          return "拔插";
        case "2":
          return "充电异常";
        case "3":
          return "温度异常";
      }
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>